"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var partial_data_export_banner_html_1 = __importDefault(require("./partial-data-export-banner.html"));
require("./partial-data-export-banner.less");
(function (module) {
    'use strict';
    module.directive('prPartialDataExportBanner', [
        function () {
            return {
                templateUrl: partial_data_export_banner_html_1.default
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
